import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
} from "@mui/material";
import teamCover_advance from "../../assets/teamCover_advance.png";
import shant from "../../assets/shant.jpg";
import anant from "../../assets/anant.jpg";
import ceo_cover from "../../assets/ceo_cover2.0.png";
import noProfile from "../../assets/noProfile.jpg";


const teamMembers = [
  {
    name: "Prashantt Singh",
    role: "operations manager",
    info: "Prashant is a seasoned operations manager with years of field experience in optimizing processes and ensuring efficient project execution across various industries.",
    image: shant,
  },
  {
    name: "Anant Singh",
    role: "Sales Manager",
    info: "Anant is a dynamic sales manager with a proven track record of driving revenue growth and building strong client relationships in competitive markets.",
    image: anant,
  },
  {
    name: "Gaurav Kumar",
    role: "CS Accounts",
    info: "Gaurav is a dedicated CS professional with expertise in managing accounts, handling legal compliance, and ensuring business operations requirements.",
    image: noProfile,
  },
  {
    name: "Shikha Singh",
    role: "Jr. Accounts Executive",
    info: "Shikha is a skilled accountant with expertise in financial reporting, tax compliance, and budgeting.",
    image: noProfile,
  },
];

export default function OurTeamSection() {
  return (
    <Box>
      {/* ================= TEAM HERO IMAGE ================= */}
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1,
            backgroundColor: "#1c17038f",
          }}
        ></Box>
        <Box
          sx={{
            height: { xs: 300, md: 600 },
            backgroundImage: `url(${teamCover_advance})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      </Box>

      {/* ================= CHAIRMAN MESSAGE ================= */}
      <Box sx={{ position: "relative" }}>
        <Box
          component="img"
          src={ceo_cover}
          alt="Chairman Message"
          sx={{
            width: "100%",
            // position: "absolute",
            // top: 0,
            // left: 0,
            // zIndex: 1,
          }}
        />
        {/* <Container
          maxWidth="lg"
          sx={{ py: { xs: 6, md: 10 } }}
          style={{ position: "relative", zIndex: "2" }}
        >
          <Grid container spacing={1} alignItems="center">
            <Typography variant="h1" fontWeight={700} gutterBottom>
              Shravan Kumar Vishwakarma
            </Typography>
            <Typography variant="body1" color="initial">
              Chairman / Founder
            </Typography>
            <Typography variant="body1" color="initial">
              Mr. Vishwakarma’s entrepreneurial journey began in 2014 with his
              entry into the cement industry. Through strategic vision,
              disciplined execution, and a commitment to long-term growth, he
              gradually expanded his ventures into TMT steel, mining, and
              transport, building a diversified and resilient business
              portfolio. Among his notable achievements is the establishment of
              an extensive logistics network, with ownership of a fleet
              exceeding 400 trucks. This steady and structured expansion not
              only strengthened the foundation of his enterprises but also
              provided the capital strength and confidence to venture into more
              complex and capital-intensive sectors.
            </Typography>
          </Grid>
        </Container> */}
      </Box>

      {/* ================= TEAM MEMBERS ================= */}
      <Box sx={{ backgroundColor: "#f7f7f7", py: { xs: 6, md: 10 } }}>
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            gutterBottom
            className="meetTeam"
          >
            Meet Our Team
          </Typography>

          <Grid container spacing={4} sx={{ mt: 4 }}>
            {teamMembers.map((member, index) => (
              <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
                <Card
                  sx={{
                    textAlign: "center",
                    p: 4,
                    borderRadius: 3,
                    boxShadow: 2,
                    transition: "0.3s",
                    position: "relative",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: 6,
                      ".cardDesignation": {
                        backgroundColor: "#525252",
                        transition: "0.3s all ease-in-out",
                      },
                    },
                  }}
                >
                  <Avatar
                    src={member.image}
                    alt={member.name}
                    sx={{
                      width: 140,
                      height: 140,
                      margin: "0 auto",
                      mb: 2,
                      border: "4px solid #f5b000",
                    }}
                  />
                  <CardContent>
                    <Typography
                      variant="h6"
                      fontWeight={200}
                      mb={3}
                      sx={{ fontSize: "30px", color: "#656565" }}
                    >
                      {member.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        mb: 2,
                        maxWidth: "calc(100% - 25%)",
                        textAlign: "justify",
                        display: "inline-block",
                      }}
                    >
                      {member.info}
                    </Typography>
                    <Typography variant="body2" className="cardDesignation">
                      {member.role}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}
